interface DBIconProps {
    className?: string;
}

export default function DBIcon({ className = 'w-6 h-6' }: DBIconProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 165.65 191.89"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Dark base layer */}
            <path
                fill="#1e448a"
                d="M165.65,40.46v133.58c0,8.21-37.07,17.86-82.82,17.86S0,182.25,0,174.03V40.46c0-8.21,37.07-14.86,82.83-14.86s82.82,6.64,82.82,14.86Z"
            />
            {/* Mid layer */}
            <path
                fill="#2f67b6"
                d="M165.65,66.66v55.58c0,8.21-37.07,14.86-82.82,14.86S0,130.45,0,122.23v-55.58c0-8.21,37.07-14.86,82.83-14.86s82.82,6.64,82.82,14.86Z"
            />
            {/* Upper layer */}
            <path
                fill="#4a91d4"
                d="M165.65,14.86v52.58c0,8.21-37.07,14.86-82.82,14.86S0,75.65,0,67.44V14.86C0,6.64,37.07,0,82.83,0s82.82,6.64,82.82,14.86Z"
            />
            {/* Top highlight ellipse */}
            <path
                fill="#79c7f3"
                d="M165.65,13.87c0,7.67-37.07,13.87-82.82,13.87S0,21.53,0,13.87,37.07,0,82.83,0s82.82,6.2,82.82,13.87Z"
            />
        </svg>
    );
}
